import Media from './media';

type Background = {
  color: string;
  media: Media | null;
};

export class Section {
  bacground: Background;

  components: Array<any>;

  id: string;

  constructor(props: any) {
    this.id = props.id || props.sys.id;
    this.bacground = {
      color: props.backgroundColor,
      media: props.backgroundElement ? new Media(props.backgroundElement) : null
    };
    this.components = props.components;
  }
}

export default Section;
